module.exports = __webpack_public_path__ + "img/bonardDesk.3cf3ce6c.png";